import { render, staticRenderFns } from "./PoliciaFederal.vue?vue&type=template&id=40ff953c&scoped=true&"
import script from "./PoliciaFederal.vue?vue&type=script&lang=js&"
export * from "./PoliciaFederal.vue?vue&type=script&lang=js&"
import style0 from "./PoliciaFederal.vue?vue&type=style&index=0&id=40ff953c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff953c",
  null
  
)

export default component.exports